export default {
    computed: {
        filesToFetch() {
            return this.proxyFiles.filter(
                file =>
                    file.serverUuid &&
                    file.isFetchingInfo === false &&
                    (file.name === null || file.size === null)
            )
        },
        filesToShowInList() {
            return this.proxyFiles.filter(file => file.serverUuid)
        },
        showDropzone() {
            return this.auth && this.baseURL && this.showDrop;
        },
        translations() {
            return {
                'pl': {
                    'dictFileTooBig': 'Plik jest za duży ({{filesize}}MB). Maksymalny rozmiar: {{maxFilesize}}MB.',
                    'dictInvalidFileType': 'Nieobsługiwany typ pliku.',
                    'dictResponseError': 'Błąd serwera: {{statusCode}}'
                },
                'en': {
                    'dictFileTooBig': 'File is too big ({{filesize}})MB. Max filesize: {{maxFilesize}}MB.',
                    'dictInvalidFileType': 'Unsupported file type.',
                    'dictResponseError': 'Server error: {{statusCode}}'
                }
            }[this.locale];
        }
    },
    watch: {
        savedFiles() {
            if (JSON.stringify(this.savedFiles) === JSON.stringify(this.value)) {
                return;
            }
            this.$emit('input', [...this.savedFiles]);
        }
    },
    methods: {
        remove(file) {
            this.beforeDeleteFn(file)
                .then(() => {
                    this.proxyFiles = this.proxyFiles.filter(f => f.serverUuid !== file.serverUuid);
                    this.$emit('fileRemoved', file)
                })
                .catch(() => {})
        },
        getFileIndexByServerUuid(serverUuid) {
            return this.proxyFiles.findIndex(file => file.serverUuid === serverUuid);
        }
    },
    data: () => ({
        busy: false,
        proxyFiles: [],
    })
}